// extracted by mini-css-extract-plugin
export default {"loader":"LogoLoader_loader__BH5D9","spin":"LogoLoader_spin__Sw5wE","content":"LogoLoader_content__hWGdj","logo":"LogoLoader_logo__pwrqM","text":"LogoLoader_text__3POj7"};